var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "filter",
    [
      _c("feColorMatrix", {
        attrs: {
          type: "matrix",
          values: "1 0 0 0 0 0 2 0 0 0 0 0 0 .5 0 0 0 0 1 0"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }